// removed by extract-text-webpack-plugin
module.exports = {"Checkbox":"U8maGhx9mImVMcp_S-JRQ","Checkbox__bar":"ruVe4B86UfsDIGQ7ZiEuW","Checkbox--with-label":"_1MVq7403kYETw5UQZzvwNj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.scss
// module id = 2600
// module chunks = 0